import View from './view';
import React from 'react';
import {IOwnProps} from './model';
import {Screens} from '../../../../../shared/routing';
import {getProfileRequests} from '../../../../../redux/actions/profile';
import {useDispatch} from 'react-redux';

export const CreateRequestMobile: React.FC<IOwnProps> = ({navigation}) => {
  const dispatch = useDispatch();
  return React.createElement(View, {
    onSuccessFormSubmit() {
      navigation.navigate(Screens.SupportServiceTopics);
      dispatch(getProfileRequests());
    },
  });
};
